import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { IColunasGrid } from "../../model/matriz-risco-controle.model";

@Component({
	selector: '	app-grid-abas-matriz-risco',
	templateUrl: './grid-abas-matriz-risco.component.html',
	styleUrls: ['./grid-abas-matriz-risco.component.scss']
})
export class GridAbasMatrizRiscoComponent implements OnInit, OnChanges {
	@Input() visualizar: boolean = false;
	@Input() listColunas!: IColunasGrid[];
	@Input() titulo!: string;
	@Input() siglaPosicao!: string;

	private _dados: any[] = [];
	@Input()
	set dados(value: any[]) {
		this._dados = value;
		this.atualizarTabela();
	}
	get dados() {
		return this._dados;
	}

	@Output() btnRemover = new EventEmitter<any>();
	@Output() btnEditar = new EventEmitter<any>();

	displayedColumns: string[] = [];

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataSource = new MatTableDataSource<any>([]);

	constructor() {}

	ngOnInit() {
		this.atualizarColunas();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['visualizar'] || changes['listColunas']) {
			this.atualizarColunas();
		}
	}

	atualizarColunas() {
		this.displayedColumns = this.listColunas?.map(c => c.id) || [];

		// A coluna 'acoes' deve sempre existir
		this.displayedColumns.push('acoes');
	}

	editar(element: any) {
		this.btnEditar.emit(element);
	}

	excluir(element: any) {
		this.btnRemover.emit(element);
		setTimeout(() => {
			this.atualizaPosicoes();
		}, 500);
	}

	moveUp(element: any) {
		let index = element.posicao - 1;
		moveItemInArray(this.dados, index, index - 1);
		this.atualizaPosicoes();
	}

	moveDown(element: any) {
		let index = element.posicao - 1;
		moveItemInArray(this.dados, index, index + 1);
		this.atualizaPosicoes();
	}

	atualizaPosicoes() {
		for (let i = 0; i < this.dados.length; i++) {
			this.dados[i].posicao = i + 1;
		}
		this.atualizarTabela();
	}

	atualizarTabela() {
		if (!this._dados) return;

		this.dataSource = new MatTableDataSource<any>(this._dados);
		this.dataSource._updateChangeSubscription();

		this.dataSource.sortingDataAccessor = (item: any, property) => {
			switch (property) {
				case 'posicao':
					return item?.posicao;
				default:
					return item[property];
			}
		};

		this.dataSource.paginator = this.paginator;
	}
}
